module.exports = __webpack_public_path__ + "static/img/cont3105.bfb61f1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/news/cont3105.jpg
// module id = eUl1
// module chunks = 0